import { useSelector } from "react-redux";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { selectListItems } from "../../../../../../redux/payouts/selector";
import { payouts } from "../../../../../../redux/payouts/action";


const ManagementPayouts = () => {
	const dispatch = useAppDispatch()
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
    const orderItems = useSelector(selectListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
        //   { field: 'PayoutTargetTypeId', headerName: 'Account Type', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraries.PayoutTargetType } },
          { field: 'PayoutTargetName', headerName: 'Account Name' },
          { field: 'PayoutAmount', headerName: 'Payout Amount' },
        //   { field: 'PayoutStatusId', headerName: 'PayoutTarget Type', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraries.PayoutStatus } },
          { field: 'PayoutDuration', headerName: 'Payout Duration' },
        //   {
        //     field: 'IsApproved',
        //     headerName: 'Approved',
        //     cellRenderer: 'yesNoRenderer'
        //   },
        //   { field: 'PayoutMethodTypeId', headerName: 'Payout Method', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraries.PayoutMethodType } },
         { field: 'CreatedOnUtc', headerName: 'Created On' },
        //  { field: 'Approve Payout', headerName: 'Approve Payout', cellRenderer: 'buttonRenderer',
        //  buttonName: 'Approve Payout', },
          { field: 'ModifiedOnUtc', headerName: 'Modified On'},
      
        ]);
      }
    
	useEffect(() => {
        createColumnDefs()
		dispatch(payouts.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/payouts/list`,entity:'payouts',jsonData:{
          
        }}))
	}, [])

	return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
   <div className="flex items-start w-full">
				<nav className="text-sm font-semibold my-3 w-full" aria-label="Breadcrumb">
					<ol className="list-none p-0 inline-flex">
						<li className="flex items-center text-blue-500">
							<a href="/management/home" className="text-gray-700"><FormattedMessage id="Home" /></a>
							<svg className="fill-current w-3 h-3 mx-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" /></svg>
						</li>
						<li className="flex items-center">
							<a href="#" className="text-gray-600"><FormattedMessage id="Payouts" /></a>
						</li>
					</ol>
				</nav>
			</div>
		<Table columnData={columnDefs} rowData={orderItems?.result?.items}  />
        </div>
     
	);
};

export default ManagementPayouts;


